<template>
  <div class="leave-tile">
    <div class="content-container" @click="modalVisible = true">
      <div class="is-flex">
        <h1 class="is-size-7 has-text-weight-bold is-expanded">
          {{ leave.employeeId }}
        </h1>
        <p class="is-size-7 is-uppercase">
          <span class="has-text-weight-bold">From: </span>
          {{ leave.startDate | date }}
        </p>
      </div>
      <h1 class="is-size-5">{{ leave.name }}</h1>
      <div class="is-flex">
        <p class="is-size-6 is-expanded">{{ leave.mobile }}</p>
        <p class="is-size-7 is-uppercase" style="margin-top: 4px;">
          <span class="has-text-weight-bold">To: </span>
          {{ leave.endDate | date }}
        </p>
      </div>
    </div>
    <div class="modal" :class="{ 'is-active': modalVisible }">
      <div class="modal-background" @click="onModalClose"></div>
      <div class="modal-content">
        <div class="box">
          <ul>
            <li class="list-item">
              <router-link
                :to="`/request/leave/view/${leave._id}`"
                class="has-text-grey"
                >View</router-link
              >
            </li>
            <li class="list-item">
              <router-link
                :to="`/request/leave/edit/${leave._id}`"
                class="has-text-grey"
                >Edit</router-link
              >
            </li>
            <li class="list-item">
              <router-link
                :to="`/request/leave/delete/${leave._id}`"
                class="has-text-danger"
                >Delete</router-link
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-close" @click="onModalClose"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["leave"],
  data() {
    return {
      modalVisible: false
    };
  },
  methods: {
    onModalClose() {
      let component = this;
      component.modalVisible = false;
      console.log("modal-close");
    }
  }
};
</script>
<style lang="scss" scoped>
.leave-tile {
  border-bottom: 1px solid $white-ter;
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  &:last-of-type {
    border-bottom-color: transparent;
  }

  .modal {
    .box {
      width: 95%;
      margin: auto;
      text-align: center;
    }
  }
}
</style>
